var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-732 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167042",
    "data-name": "Group 167042",
    transform: "translate(688 -212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83179",
    "data-name": "Path 83179",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    transform: "translate(44 453)",
    fill: "#f2f3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "info-2",
    "data-name": "info",
    transform: "translate(743 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9394",
    "data-name": "Ellipse 9394",
    d: "M10-.75A10.75,10.75,0,0,1,17.6,17.6,10.75,10.75,0,0,1,2.4,2.4,10.68,10.68,0,0,1,10-.75Zm0,20A9.25,9.25,0,1,0,.75,10,9.26,9.26,0,0,0,10,19.25Z",
    transform: "translate(2 2)",
    fill: "#636974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_462",
    "data-name": "Line 462",
    d: "M0,4.75A.75.75,0,0,1-.75,4V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V4A.75.75,0,0,1,0,4.75Z",
    transform: "translate(12 12)",
    fill: "#636974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_463",
    "data-name": "Line 463",
    d: "M.01.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H.01A.75.75,0,0,1,.76,0,.75.75,0,0,1,.01.75Z",
    transform: "translate(12 8)",
    fill: "#636974"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.7fd54f9dbd9ecd352300919d3c675d9f.svg";
export { ForwardRef as ReactComponent };